import { useCallback, useEffect, useRef } from "react";

/**
 * Debounces a callback so it runs only after a pause.
 * Useful when input should feel instant but API calls should be delayed.
 */
const useDebouncedCallback = (callback, delay = 300) => {
  const callbackRef = useRef(callback);
  const timerRef = useRef(null);

  useEffect(() => {
    callbackRef.current = callback;
  }, [callback]);

  useEffect(() => {
    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
    };
  }, []);

  return useCallback(
    (...args) => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }

      timerRef.current = setTimeout(() => {
        callbackRef.current(...args);
      }, delay);
    },
    [delay]
  );
};

export default useDebouncedCallback;
